var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChallenge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2c1.946 0 3.761.558 5.298 1.52l-1.094 1.093a8.5 8.5 0 103.182 3.182L20.48 6.7A9.95 9.95 0 0122 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 6c.831 0 1.623.169 2.343.475l-1.178 1.177a4.5 4.5 0 103.182 3.182l1.177-1.178A6 6 0 1112 6z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 1.25a.75.75 0 01.75.75v1.25H22a.75.75 0 010 1.5h-1.69l-6.47 6.469a2 2 0 11-1.06-1.06l6.47-6.47V2a.75.75 0 01.75-.75zM12 11.5a.5.5 0 100 1 .5.5 0 000-1z",
    fill: "currentColor"
  })));
}
SvgChallenge.displayName = 'Challenge';
export default SvgChallenge;